import { render, staticRenderFns } from "./IconPause.vue?vue&type=template&id=910848a6&"
import script from "./IconPause.vue?vue&type=script&lang=js&"
export * from "./IconPause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports